/* Store customization restored from live Eurus 10.2.0: swatch placement and row alignment. */
;(() => {
  if (window.SaharaProductCardRowAligner) return;
  window.SaharaProductCardRowAligner = true;

  const selectors = {
    card: '.card-product',
    title: '.card__heading',
    price: '.x-card-price',
    options: '.x-variants-data-js'
  };
  const swatchOrigins = new WeakMap();

  const getVisibleCards = () => Array.from(document.querySelectorAll(selectors.card)).filter((card) => (
    card.offsetParent !== null &&
    !card.closest('.quick-view, #QuickView, .product-card-cbl-clone')
  ));

  const syncProductCardSwatchPosition = () => {
    Array.from(document.querySelectorAll(selectors.card)).forEach((card) => {
      if (card.closest('.quick-view, #QuickView, .product-card-cbl-clone')) return;

      const options = card.querySelector(selectors.options);
      if (!options) return;

      if (!swatchOrigins.has(options)) {
        const marker = document.createComment('sahara-card-swatch-origin');
        options.parentNode.insertBefore(marker, options);
        swatchOrigins.set(options, marker);
      }

      const title = card.querySelector('.card-info.md\\:list-layout\\:hidden .card__heading') ||
        Array.from(card.querySelectorAll('.card-info .card__heading')).find((element) => (
          element.offsetParent !== null
        )) ||
        card.querySelector('.card-info .card__heading');
      if (!title || options.nextElementSibling === title) return;

      title.parentNode.insertBefore(options, title);
      options.classList.add('sahara-card-swatches-above-title');
    });
  };

  const resetCard = (card) => {
    card.style.removeProperty('--sahara-card-title-height');
    card.style.removeProperty('--sahara-card-price-height');
    card.style.removeProperty('--sahara-card-options-height');
  };

  const getVisibleElement = (card, selector) => Array.from(card.querySelectorAll(selector)).find((element) => {
    const rect = element.getBoundingClientRect();
    return element.offsetParent !== null && rect.width > 0 && rect.height > 0;
  }) || null;

  const getHeight = (card, selector) => {
    const element = getVisibleElement(card, selector);
    return element ? Math.ceil(element.getBoundingClientRect().height) : 0;
  };

  const getTitleMetrics = (card) => {
    const title = getVisibleElement(card, selectors.title);
    if (!title) return { height: 0, lines: 0 };

    const height = Math.ceil(title.getBoundingClientRect().height);
    const computedStyle = window.getComputedStyle(title);
    const fontSize = parseFloat(computedStyle.fontSize) || 16;
    const lineHeight = parseFloat(computedStyle.lineHeight) || fontSize * 1.2;

    return {
      height,
      lines: Math.max(1, Math.round(height / lineHeight))
    };
  };

  window.saharaAlignProductCardRows = () => {
    syncProductCardSwatchPosition();

    const cards = getVisibleCards();
    const rows = [];

    cards.forEach(resetCard);

    cards.forEach((card) => {
      const top = Math.round(card.getBoundingClientRect().top);
      let row = rows.find((candidate) => Math.abs(candidate.top - top) < 8);

      if (!row) {
        row = { top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
    });

    rows.forEach((row) => {
      if (row.cards.length < 2) return;

      const titleMetrics = row.cards.map(getTitleMetrics);
      const titleHeight = Math.max(...titleMetrics.map((metrics) => metrics.height));
      const priceHeight = Math.max(...row.cards.map((card) => getHeight(card, selectors.price)));
      const optionsHeight = Math.max(...row.cards.map((card) => getHeight(card, selectors.options)));

      row.cards.forEach((card) => {
        if (titleHeight) card.style.setProperty('--sahara-card-title-height', `${titleHeight}px`);
        if (priceHeight) card.style.setProperty('--sahara-card-price-height', `${priceHeight}px`);
        if (optionsHeight) card.style.setProperty('--sahara-card-options-height', `${optionsHeight}px`);
      });
    });
  };

  const schedule = () => {
    cancelAnimationFrame(window.saharaProductCardRowsFrame);
    window.saharaProductCardRowsFrame = requestAnimationFrame(window.saharaAlignProductCardRows);
  };

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('eurus:product-card-variant-select:updated', schedule, true);
  window.saharaScheduleProductCardRows = schedule;

  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  schedule();
  setTimeout(schedule, 250);
  setTimeout(schedule, 750);
  document.fonts?.ready?.then(schedule);
})();
